import React from 'react';
import { Link } from 'react-router-dom';
import { FaGhost, FaGithub, FaTwitter, FaDiscord } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-8 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <FaGhost className="text-2xl text-boop-primary" />
              <span className="text-xl font-bold text-white">Boop</span>
            </div>
            <p className="text-sm text-gray-400">
              Best of Online Prompts - Your community for sharing and improving AI prompts.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/dashboard" className="hover:text-boop-primary transition">Browse Prompts</Link></li>
              <li><Link to="/leaderboard" className="hover:text-boop-primary transition">Leaderboard</Link></li>
              <li><Link to="/token-analyzer" className="hover:text-boop-primary transition">Token Analyzer</Link></li>
              <li><Link to="/prompts/create" className="hover:text-boop-primary transition">Create Prompt</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-boop-primary transition">About</Link></li>
              <li><Link to="/docs" className="hover:text-boop-primary transition">Documentation</Link></li>
              <li><Link to="/faq" className="hover:text-boop-primary transition">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-boop-primary transition">Contact</Link></li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-white font-semibold mb-4">Community</h3>
            <div className="flex space-x-4">
              <a href="https://github.com/boop-ai" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-boop-primary transition">
                <FaGithub />
              </a>
              <a href="https://twitter.com/boopai" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-boop-primary transition">
                <FaTwitter />
              </a>
              <a href="https://discord.gg/boop" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-boop-primary transition">
                <FaDiscord />
              </a>
            </div>
            <p className="text-sm mt-4 text-gray-400">
              Join our community to stay updated!
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Boop Platform. All rights reserved.</p>
          <p className="mt-2">
            <Link to="/privacy" className="hover:text-boop-primary transition">Privacy Policy</Link>
            {' · '}
            <Link to="/terms" className="hover:text-boop-primary transition">Terms of Service</Link>
            {' · '}
            <Link to="/contact" className="hover:text-boop-primary transition">Contact</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
